import { useWhiteLabelling } from 'components/WhiteLabellingProvider';
import { useAccess, Permission, Scope } from 'hooks/useAccess';
import useIsApprovedUser from 'hooks/useIsApprovedUser';
import useUser from 'hooks/useUser';
import useMarketInput from './useMarketInput';

/*
 * Hook to determine if the market query should be paused based on user state and permissions
 */
const useIsMarketQueryPaused = () => {
  const has = useAccess();
  const { isSeller, user } = useUser();
  const { isInputsType } = useWhiteLabelling();
  const { isMarketStateInitialized } = useMarketInput();
  const isApprovedUser = useIsApprovedUser();

  const isMarketQueryPaused =
    !isMarketStateInitialized ||
    isSeller ||
    !isApprovedUser ||
    !user?.profileId ||
    !has(Permission.Market, Scope.Read) ||
    isInputsType;

  return isMarketQueryPaused;
};

export default useIsMarketQueryPaused;
